module.exports = __webpack_public_path__ + "img/rice_n.c7b4354a.png";